import {Tooltip} from "primereact/tooltip";
import {
    formatISOToBasicDateFormat,
    formatValueWithGivenDecimalPlace,
    numberArrayToBooleanConverter
} from "../dashboard/data-input-output-table/utils";
import React, {useEffect} from "react";
import {DatasetOverrideTitleConfig} from "../../models/dataset-models";
import {InputSwitch} from "primereact/inputswitch";
import {InstantDoubleValue} from "../../api/model/dataset/InstantDoubleValue";

export const TitleOverrideAndDescriptionTemplate = (data: DatasetOverrideTitleConfig, version?: number) => {
    const pointerOnElement = React.useState(false);

    useEffect(() => {
        document.addEventListener("keydown", keyPressedToCopy);
        return () => {
            document.removeEventListener("keydown", keyPressedToCopy);
        }
    }, []);

    const onPointerElementHandler = (e: any) => {
        if (e.type === "pointerenter" && !pointerOnElement[0]) {
            pointerOnElement[0] = true;
        } else if (e.type === "pointerleave" && pointerOnElement[0]) {
            pointerOnElement[0] = false;
        }
    }

    const keyPressedToCopy = (e: any) => {
        if (pointerOnElement[0]) {
            if (e.code === "KeyC" && e.ctrlKey) {
                e.preventDefault();
                textToClipboard(data.title);
                PF('globalGrowl').renderMessage(
                    {
                        "summary": "Copied Dataset tag",
                        "detail": data.title,
                        "severity": "info"
                    }
                );
            }
        }
    }

    if (data.overriddenTitle || data.overriddenTitle === " ") {
        let title = data?.unit ? ", " + data.unit : "";
        if (!version || version === 1) {
            return (
                <div style={{
                    whiteSpace: "break-spaces",
                    wordBreak: "break-word",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "3px",
                    width: "100%"

                }}>
                    <Tooltip target=".custom-tooltip-class" position={"bottom"}/>
                    <Tooltip target=".custom-target-icon" position={"bottom"}/>

                    <div style={{display: "flex", alignItems: "center", flexDirection: "row"}}>
                        <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap"}}>
                            <div>{data.overriddenTitle}
                                {data.unit && data.unit !== " " && data.overriddenTitle.length > 0 && data.overriddenTitle !== " " &&
                                    ", "
                                }
                            </div>
                            <div style={{wordBreak: "keep-all"}}>
                                {data.unit && data.unit !== " " ? data.unit : ""}
                            </div>
                        </div>
                        <div className={"custom-tooltip-class non-printable"}
                             data-pr-tooltip={data.title + title}
                             style={{paddingLeft: "3px"}}
                        >
                            <i className='pi pi-info-circle'
                               onPointerEnter={(e) => onPointerElementHandler(e)}
                               onPointerLeave={(e) => onPointerElementHandler(e)}/>
                        </div>
                    </div>
                    {data.description &&
                        <span className="custom-target-icon non-printable" data-pr-tooltip={data.description}>
                <i className="pi pi-question-circle p-text-info"/>
            </span>
                    }
                </div>)
        } else if (version === 2) {
            return (
                <div style={{
                    whiteSpace: "break-spaces",
                    wordBreak: "break-word",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "3px",
                    flexDirection: "column",
                    width: "100%"

                }}>
                    <Tooltip target=".custom-tooltip-class" position={"bottom"}/>
                    <Tooltip target=".custom-target-icon" position={"bottom"}/>

                    <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap"}}>
                        <div>{data.overriddenTitle}
                            {data.unit && data.unit !== " " && data.overriddenTitle.length > 0 && data.overriddenTitle !== " " &&
                                ", "
                            }
                        </div>
                        <div style={{wordBreak: "keep-all"}}>
                            {data.unit && data.unit !== " " ? data.unit : ""}
                        </div>
                    </div>
                    <div className={"non-printable"} style={{display: "flex", gap: "8px"}}>
                        <div className={"custom-tooltip-class "}
                             data-pr-tooltip={data.title + title}
                        >
                            <i className='pi pi-info-circle'
                               onPointerEnter={(e) => onPointerElementHandler(e)}
                               onPointerLeave={(e) => onPointerElementHandler(e)}/>
                        </div>
                        {data.description &&
                            <span className="custom-target-icon non-printable" data-pr-tooltip={data.description}>
                            <i className="pi pi-question-circle p-text-info"/>
                        </span>
                        }
                    </div>

                </div>)
        }


    }
    if (!version || version === 1) {
        return <div style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-word",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "3px",
            flexGrow: "1",
            width: "100%"
        }}>
            <Tooltip target=".custom-target-icon" position={"bottom"}/>
            <div style={{display: "flex", alignItems: "justifyContent", flexWrap: "wrap"}}>
                <div>{data.title}
                    {data.title && data.title !== " " && data.unit && data.unit !== " " && ", "}
                </div>
                <div style={{wordBreak: "keep-all"}}>
                    {data.unit && data.unit !== " " ? data.unit : ""}
                </div>
            </div>
            {data.description &&
                <div className="custom-target-icon" data-pr-tooltip={data.description}>
                    <i className="pi pi-question-circle p-text-info"/>
                </div>
            }
        </div>
    } else if (version === 2) {
        return <div style={{
            whiteSpace: "break-spaces",
            wordBreak: "break-word",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            alignItems: "center",
            gap: "3px",
            flexGrow: "1",
            width: "100%"
        }}>
            <Tooltip target=".custom-target-icon" position={"bottom"}/>
            <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap"}}>
                <div>{data.title}
                    {data.title && data.title !== " " && data.unit && data.unit !== " " && ", "}
                </div>
                <div style={{wordBreak: "keep-all"}}>
                    {data.unit && data.unit !== " " ? data.unit : ""}
                </div>
            </div>
            {data.description &&
                <div className="custom-target-icon non-printable" data-pr-tooltip={data.description}>
                    <i className="pi pi-question-circle p-text-info"/>
                </div>
            }
        </div>
    }
}

export const NumberTypeTemplate = (data: Array<InstantDoubleValue>, unit: String, decimalPlaces?: number) => {
    if (data.length > 0) {
        return <>
            <Tooltip target=".labelData" position={"left"}/>
            <span className='labelData' data-pr-tooltip={formatISOToBasicDateFormat(data[0].key as string)}>
                {formatValueWithGivenDecimalPlace(data[data.length - 1].value, unit, decimalPlaces)}
            </span>
        </>
    } else {
        return "-";
    }
}

export const BooleanTypeTemplate = (data: Array<InstantDoubleValue>, onChange?: (value: boolean) => void) => {
    if (data.length > 0) {
        return <>
            <Tooltip target=".labelData" position={"left"}/>
            <span className='labelData' data-pr-tooltip={formatISOToBasicDateFormat(data[0].key as string)}>
                <InputSwitch checked={numberArrayToBooleanConverter(data)}
                             onChange={(e) => onChange ? onChange(e.value) : null}
                             disabled={!onChange}
                />
            </span>
        </>
    } else {
        return "-";
    }
}